import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    ActivitiesMutationResourceSchema,
    type ActivitiesResource,
    defaultActivitiesResource,
    useActivitiesActions,
} from '../../../../../resource/resources/artifacts/activities/activitiesResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { creationDialogOnSuccess } from '../../../../util/utilFunctions';
import { ActivityContent } from './ActivityContent';

export const ActivityCreationDialog = ({
    onClose,
    parentId,
    autoGeneratedProps,
    onCreated,
}: {
    onClose: () => void;
    parentId: string;
    autoGeneratedProps?: ActivitiesResource;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const activitiesActions = useActivitiesActions();
    const addActivities = activitiesActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: ActivitiesMutationResourceSchema,
        defaultValues: {
            ...defaultActivitiesResource,
            ...autoGeneratedProps,
        },
        submitHandler: async (data) => {
            await addActivities.mutateAsync(
                {
                    resource: data,
                    parentId,
                },
                {
                    onSuccess: creationDialogOnSuccess(onCreated, onClose),
                }
            );
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create Activity'}
            resourceType={ResourceType.ACTIVITIES}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <ActivityContent form={form} formNames={formNames} readOnly={false} />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};
